import { render, staticRenderFns } from "./Pengaturan.vue?vue&type=template&id=1427430d&scoped=true"
import script from "./Pengaturan.vue?vue&type=script&lang=js"
export * from "./Pengaturan.vue?vue&type=script&lang=js"
import style0 from "./Pengaturan.vue?vue&type=style&index=0&id=1427430d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1427430d",
  null
  
)

export default component.exports